<script setup lang="ts">
import StatusDot from '../ui/StatusDot.vue'
import type { Tone } from '~/utils/state'

/** 28px nav row. The number is how many objects the section holds; the dot in front says work is in flight there (founder 2026-09-10). */
defineProps<{ label: string; to: string; active?: boolean; count?: number | null; tone?: Tone }>()
</script>

<template>
  <NuxtLink
    :to="to"
    class="relative flex h-7 shrink-0 items-center gap-2 rounded-[var(--radius-control)] pl-3 pr-2 text-[length:var(--type-control)] no-underline hover:no-underline"
    :class="active ? 'bg-sidebar-accent font-semibold text-foreground' : 'text-sidebar-foreground hover:bg-sidebar-accent/60'"
  >
    <span v-if="active" class="absolute inset-y-[var(--measure-7px)] left-0 w-0.5 rounded-full bg-gradient-primary shadow-glow-primary" />
    <span class="[&_svg]:size-[var(--measure-15px)] [&_svg]:shrink-0" :class="active && '[&_svg]:text-primary'"><slot name="icon" /></span>
    <span class="flex-1 truncate">{{ label }}</span>
    <span v-if="count" class="num inline-flex items-center gap-1.5 text-[length:var(--type-fine)] text-muted-foreground">
      <StatusDot v-if="tone" status="" :tone="tone" />{{ count }}
    </span>
  </NuxtLink>
</template>
